import { NgModule } from "@angular/core";
import { FlexLayoutModule } from '@angular/flex-layout'; // imp (grid layout)
import { NgxSpinnerModule } from "ngx-spinner";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BreadcrumbComponent } from "src/app/common-components/breadcrumb/breadcrumb.component";
import { NotFoundComponent } from 'src/app/common-components/not-found/not-found.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import {LogoutComponent} from 'src/app/common-components/logout/logout.component';
//translation module added
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
// result not found component
import { ResultNotFoundComponent } from "../common-components/result-not-found/result-not-found.component";
// delete modal
import { DeleteModalComponent } from 'src/app/common-components/delete-modal/delete-modal.component';

//drag and drop use for project current status for update sequence
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MaterialModule } from "./material.module";
import { PopUpComponent } from "../common-components/pop-up/pop-up.component";

import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClient } from "@angular/common/http";



import { GaugeChartModule } from 'angular-gauge-chart'
import { CommonPopUpComponent } from "../common-components/common-pop-up/common-pop-up.component";
import { Gc_company_nameComponent } from "../common-components/gc_company_name/gc_company_name.component";
import { ChartComponent } from "../shared/chart/chart.component";
import { CompanySwitcherModalComponent } from "../common-components/company-switcher-modal/company-switcher-modal.component";
import { PaginationComponent } from "../common-components/pagination/pagination.component";
import { TransliteratePipe } from "../common-services/transliterate.pipe";

import { ExpandableTextComponent } from "../common-components/expandable-text/expandable-text.component";
import { DescriptionModalComponent } from "../common-components/expandable-text/description-modal.component";
import { ModifyOnlyDirective } from "../common-directives/modify-only.directive";
import { ReadOnlyScopeDirective } from "../common-directives/read-only-scope.directive";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new MultiTranslateHttpLoader(http, [
        { prefix: "../../assets/translations/", suffix: ".json" },
        // {prefix: "./assets/translate/shared/", suffix: ".json"},
    ]);
}

@NgModule({
    declarations: [
        BreadcrumbComponent,
        NotFoundComponent,
        ResultNotFoundComponent,
        DeleteModalComponent,
        PopUpComponent,
        LogoutComponent,
        CommonPopUpComponent,
        Gc_company_nameComponent,
        ChartComponent,
        CompanySwitcherModalComponent,
        PaginationComponent,
        TransliteratePipe,
        ExpandableTextComponent,
        DescriptionModalComponent,
        ModifyOnlyDirective,
        ReadOnlyScopeDirective
    ],
    entryComponents: [
        DescriptionModalComponent
    ],
    imports: [
        FlexLayoutModule,
        NgxSpinnerModule,
        FontAwesomeModule,
        DragDropModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MaterialModule,
        NgSelectModule,
        
        GaugeChartModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
      


    ],
    exports: [
        CommonModule,
        FlexLayoutModule,
        NgxSpinnerModule,
        FontAwesomeModule,
        BreadcrumbComponent,
        NotFoundComponent,
        ResultNotFoundComponent,
        DeleteModalComponent,
        PopUpComponent,
        CommonPopUpComponent,
        TranslateModule,
        LogoutComponent,
        FormsModule,
        ReactiveFormsModule,
        
        GaugeChartModule,
        Gc_company_nameComponent,
        ChartComponent,
        CompanySwitcherModalComponent,
        PaginationComponent,
        TransliteratePipe,
        ExpandableTextComponent,
        DescriptionModalComponent,
        ModifyOnlyDirective,
        ReadOnlyScopeDirective
    ]
})

export class SharedModule {

}